<i18n src="@/i18n/components/user-box.json"></i18n>

<template>
  <div class="box" style="background-color: whitesmoke">
    <div class="level">
      <user-name-form :user="user" :event="event" :is-editable="!!user.id"></user-name-form>

      <div v-if="!!user.id || (!user.id && isInitiator)" class="level-right">
        <div class="level-item">
          <button class="button is-primary" @click="addItem">
            <span class="icon is-small">
              <i class="fa" :class="[user.items.length <= 0 ? 'fa-plus' : 'fa-pencil']"></i>
            </span>
            <span v-if="user.items.length <= 0">{{ $t('addItems') }}</span>
            <span v-else>{{ $t('manageItems') }}</span>
          </button>
        </div>
      </div>
    </div>

    <item-list-form v-if="showItemListForm" :on-close="cancelForm" :event-id="event.id" :user-id="user.id" :user-items="user.items"></item-list-form>
    <item-list v-if="!showItemListForm" :items="user.items" :user="user" :event="event"></item-list>
  </div>
</template>

<script>
  import ItemList from './ItemList.vue'
  import ItemListForm from './ItemListForm.vue'
  import UserNameForm from './UserNameForm.vue'
  import { mapState } from 'vuex'

  export default {
    name: 'user-box',
    props: {
      user: Object,
      event: Object
    },
    components: {
      ItemListForm,
      ItemList,
      UserNameForm
    },
    data () {
      return {
        showItemListForm: this.user.items.length === 0
      }
    },
    computed: {
      ...mapState({
        typesFilter: state => state.filters.types
      }),
      isInitiator () {
        return localStorage.getItem('userId') && localStorage.getItem('userId') === this.event.initiator.id
      }
    },
    methods: {
      addItem () {
        this.showItemListForm = !this.showItemListForm
        this.$ga && this.$ga.event('Items', 'click', 'add', 'First click')
      },
      cancelForm () {
        this.showItemListForm = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/UserBox.vue